import React, { useState, useContext } from 'react';
import './SpinWheel.css';
import { ShopContext } from '../../Context/ShopContext';

const options = [
  { label: '10% Men', color: '#FFBA08', type: 'mens', value: 0.10 },
  { label: '15% Women', color: '#2FA4D7', type: 'women', value: 0.15 },
  { label: '20% Kids', color: '#E76F2E', type: 'kids', value: 0.20 },
  { label: '35% off ₹3000+', color: '#3E2C23', type: 'total', value: 0.35, threshold: 3000 },
  { label: '₹100 Off Flat', color: '#89D4FF', type: 'flat', value: 100 },
  { label: 'Try Again', color: '#ccc', type: 'none', value: 0 }
];

const SpinWheel = () => {
  const [open, setOpen] = useState(false);
  const [spinning, setSpinning] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [result, setResult] = useState(null);
  
  const { applyDiscount, discountCode } = useContext(ShopContext);

  const spin = () => {
    if (spinning || discountCode) return;
    setSpinning(true);
    setResult(null);

    // Calculate a random slice
    const sliceAngle = 360 / options.length;
    const randomSlice = Math.floor(Math.random() * options.length);
    
    // Add extra rotations for dramatic effect (e.g. 5 full spins = 1800 degrees)
    const extraSpins = 360 * 5;
    // Calculate final angle to land securely in the middle of chosen slice
    const finalAngle = extraSpins + (randomSlice * sliceAngle) + (sliceAngle / 2);
    
    setRotation(rotation + finalAngle);

    setTimeout(() => {
      setSpinning(false);
      // Because we spun clockwise, the pointer (top) points to what rotated IN.
      // Need to calculate winning slice mapped to array properly.
      const actualRotation = (rotation + finalAngle) % 360;
      const winningIndex = Math.floor((360 - actualRotation) / sliceAngle) % options.length;
      
      const won = options[winningIndex];
      setResult(won);
      
      if (won.type !== 'none') {
        applyDiscount(won);
      }
    }, 4000); // Wait 4 seconds for CSS transition
  };

  return (
    <>
      <div className={`spin-widget-toggle ${open ? 'hide' : ''}`} onClick={() => setOpen(true)}>
        🎁 Spin & Win!
      </div>
      
      {open && (
        <div className="spin-modal-overlay">
          <div className="spin-modal">
            <button className="spin-close" onClick={() => setOpen(false)}>✖</button>
            <h2>{discountCode ? "Discount Applied!" : "Lucky Spin!"}</h2>
            
            <div className="wheel-container">
              <div className="wheel-pointer">▼</div>
              <div 
                className="wheel" 
                style={{ transform: `rotate(${rotation}deg)` }}
              >
                {options.map((opt, i) => {
                  const rotationAngle = i * (360 / options.length);
                  return (
                    <div 
                      key={i} 
                      className="wheel-slice"
                      style={{ 
                        transform: `rotate(${rotationAngle}deg)` 
                      }}
                    >
                      <span style={{ backgroundColor: opt.color }}>{opt.label}</span>
                    </div>
                  );
                })}
              </div>
            </div>

            {result ? (
              <p className="spin-result">
                {result.type === 'none' ? 'Better luck next time!' : `You won: ${result.label}!` }
              </p>
            ) : (
               <p className="spin-result">Spin to unlock huge savings!</p>
            )}

            <button 
              className="spin-btn" 
              onClick={spin} 
              disabled={spinning || discountCode}
            >
              {discountCode ? "Already Claimed" : (spinning ? "Spinning..." : "SPIN NOW")}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default SpinWheel;
